export default function Footer(): JSX.Element {
    return (
        <div className="footer">
            Todos los derechos reservados © 2025
            <div className="release">Versión 2025.12.04</div>
        </div>
    );
}
